function getBrowserInfo() {
    const connectionInfos = window.navigator.connection
        || window.navigator.mozConnection
        || window.navigator.webkitConnection
        || {};
    return {
        screen: `${screen.width}x${screen.height}`,
        colorDepth: screen.colorDepth || "undefined",
        os: window.navigator.platform || "undefined",
        connectionType: connectionInfos.type || "undefined",
        metered: connectionInfos.metered || "undefined",
        bandwidth: connectionInfos.bandwidth || "undefined",
        downlinkMax: connectionInfos.downlinkMax || "undefined"
    };
}

export default {
    getBrowserInfo
};